// extracted by mini-css-extract-plugin
export var big = "Card-module--big--a71d5";
export var contentWrapper = "Card-module--contentWrapper--5495d";
export var detailIcon = "Card-module--detailIcon--9a6d6";
export var detailItem = "Card-module--detailItem--51a6b";
export var details = "Card-module--details--c7218";
export var disabled = "Card-module--disabled--a0bfc";
export var fadeInAnimation = "Card-module--fadeInAnimation--a5829";
export var image = "Card-module--image--db9da";
export var internal = "Card-module--internal--d6715";
export var picture = "Card-module--picture--9077a";
export var subtitle = "Card-module--subtitle--8898d";
export var text = "Card-module--text--ade95";
export var wrapper = "Card-module--wrapper--25160";